import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import CustomSelect from 'components/select';

import config from 'config';
import Translate from "../../../../../components/Translate";

const statusesToShow = config.statuses
    .filter(status => status.value !== config.statusMap.pending && status.value !== config.statusMap.deleted)

const statusesToShowTranslated = statusesToShow.map(s => {
    return {
        id: s.id,
        name: s.name,
        value: s.value,
        title: s.title === 'Enabled' ? <Translate text={'ENABLED'}/> : <Translate text={'DISABLED'} />
    };
});

const indicatorColorsMap = {
    [config.statusMap.pending]: '#A4ADC1',
    [config.statusMap.enabled]: '#00E3A6',
    [config.statusMap.disabled]: '#E14E52',
};


const MemberStatus = ({member, updateStatus}) => {
    const colorIndicator = (
        <div style={{
            width: '8px',
            height: '8px',
            display: 'inline-block',
            borderRadius: '50%',
            backgroundColor: indicatorColorsMap[member.status],
        }}
        />
    );

    if (member.status === config.statusMap.pending) {
        return (
            <Fragment>
                {colorIndicator}
                <span style={{paddingLeft: '10px', color: '#09183A'}}>
                    <Translate text="PENDING"/>
                </span>
            </Fragment>

        );
    }


    return (
        <Fragment>
            {colorIndicator}
            <CustomSelect
                wrapperStyles={{boxShadow: 'none', display: 'inline-block'}}
                titleStyles={{color: '#09183A'}}
                listStyles={{boxShadow: 'none', width: '140%'}}
                options={statusesToShowTranslated}
                selected={member.status}
                handleSelect={updateStatus}
                width="100px"
            />
        </Fragment>
    );
};

MemberStatus.propTypes = {
    member: PropTypes.object.isRequired,
    updateStatus: PropTypes.func.isRequired,
};

export default MemberStatus;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/MemberStatus.jsx